// noinspection TypeScriptUnresolvedReference

import type * as Sentry from '@sentry/react';
import { captureException, captureMessage } from '@sentry/react';

export function logError(...args: Parameters<typeof Sentry.captureException>) {
  if (process.env.IS_SENTRY_ENABLED) {
    captureException(...args);
  } else if (
    process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID &&
    process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN
  ) {
    void import('@datadog/browser-rum').then(({ datadogRum }) => datadogRum.addError(...args));
  } else {
    // local development
    console.error(...args);
  }
}

export function logMessage(...args: Parameters<typeof Sentry.captureMessage>) {
  if (process.env.IS_SENTRY_ENABLED) {
    captureMessage(...args);
  } else {
    // local development
    console.log(...args);
  }
}
